import React from "react";

export default function SearchBar({
  search,
  setSearch,
  setCurrentPage,
}) {
  return (
    <div className="position-relative" style={{ width: "200px" }}>
      <span
        className="position-absolute top-50 start-0 translate-middle-y ps-2"
        style={{ pointerEvents: "none" }}
      >
        <img src="/images/search.svg" alt="search" />
      </span>
      <input
        type="text"
        className="form-control ps-5"
        placeholder="Search..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setCurrentPage?.(1);
        }}
      />
    </div>
  );
}
